module.exports = __webpack_public_path__ + "img/request.9817c797.svg";